export default __webpack_public_path__ + "static/media/AboutUsPhotoBottom.cbc64826.jpg";